import { useState, useCallback } from 'react';
import { filtersReducer } from '../../_commons/filtersReducer';
// import { useLocations, AirportType } from '../../_commons/locations';
import { useOriginDestination } from '../../_commons/locations';
import { useSubscription } from './subscription';
import { useEffectReducer } from 'use-effect-reducer';

function useForm({ dispatch, value, initValue, input }) {
  const onChange = (val) => {
    const value = val || (input !== 'phoneNumber' && val === '') ? val : null;
    const payload = {
      [`${input}`]: value
    };
    dispatch({
      type: 'CLEAR_PARTIAL',
      payload
    });
  };
  const onClear = (ref) => {
    const payload = {
      [`${input}`]: ''
    };
    dispatch({
      type: 'CLEAR_PARTIAL',
      payload
    });
  };
  return { value, defaultValue: value, onChange, onClear, isChanged: initValue !== value };
}

const useFilters = ({
  ui,
  getSubscription,
  availableFilters = [],
  prePopulation,
  integrationSettings,
  meta,
  getAirports,
  pageContext
}) => {
  const [fetchData, setFetchData] = useState(false);

  const [state, dispatch] = useEffectReducer(filtersReducer, {
    firstName: prePopulation.firstName || '',
    lastName: prePopulation.lastName || '',
    origin: { value: prePopulation.origin || '' },
    destination: { value: '' },
    email: prePopulation.email || '',
    phoneNumber: prePopulation.phoneNumber || '',
    userInteraction: false,
    noClearDestination: true,
    navigation: 'all'
  });

  const locations = useOriginDestination({
    dispatch,
    origin: state.origin,
    destination: state.destination,
    showOrigin: availableFilters.includes('Origin') || availableFilters.includes('OriginMobile'),
    showDestination: true,
    filter: { getAirports, prePopulation, integrationSettings, meta, pageContext },
    initialOrigins: undefined,
    initialDestinations: [],
    originDestinationLogic: 'same',
    userInteraction: state.userInteraction
  });

  const firstName = useForm({
    dispatch,
    value: state.firstName,
    initValue: prePopulation.firstName,
    input: 'firstName'
  });
  const lastName = useForm({
    dispatch,
    value: state.lastName,
    initValue: prePopulation.lastName,
    input: 'lastName'
  });
  const phoneNumber = useForm({
    dispatch,
    value: state.phoneNumber,
    initValue: prePopulation.phoneNumber,
    input: 'phoneNumber'
  });
  const email = useForm({
    dispatch,
    value: state.email,
    initValue: prePopulation.email,
    input: 'email'
  });

  const { subscriptionInfo, match, retry } = useSubscription({
    firstName: state.firstName,
    lastName: state.lastName,
    origin: state.origin,
    email: state.email,
    phoneNumber: state.phoneNumber,
    prePopulation,
    meta,
    integrationSettings,
    getSubscription,
    getAirports,
    fetchData,
    setFetchData,
    pageContext
  });
  const uiSettings = {
    ...ui,
    form: {
      ...ui?.form,
      cta: {
        ...ui?.form?.cta,
        onClick: () => {
          setFetchData(true);
        }
      }
    }
  };

  /**
   * This function is used after x seconds for clean all filters and remove the alert from the UI.
   */
  const clearFilters = useCallback(() => {
    const newPayload = {
      firstName: '',
      lastName: '',
      origin: { value: '' },
      email: '',
      phoneNumber: null
    };
    //INFO: Put the response in false to remove the alert from the UI.
    subscriptionInfo.success = false;
    // TODO: Cleaning all filter
    dispatch({
      type: 'CLEAR_PARTIAL',
      payload: newPayload
    });
  }, [dispatch, subscriptionInfo]);

  return {
    firstName,
    lastName,
    phoneNumber,
    email,
    //INFO: It was necessary to destructure the object to add the disabled since in mobile
    //      the map's ReduceInlineFilter was reused, bringing with it the placeholder's labelKey
    //      to be the same as the map's
    locations: {
      ...locations,
      origin: {
        ...locations?.origin,
        disabled: fetchData
      }
    },
    isFetchData: fetchData,
    navigation: state?.navigation,
    uiSettings,
    dispatch,
    subscriptionInfo,
    match,
    retry,
    clearFilters
  };
};

export default useFilters;
